var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('page-header',{attrs:{"title":_vm.lang.alphaNumeric,"info":_vm.lang.alphaNumericInfo(_vm.id)}}),_vm._v(" "),_c('grid',{attrs:{"items":_vm.items,"headers":_vm.headers}}),_vm._v(" "),(_vm.id)?_c('div',{class:['meta-description'],attrs:{"hidden":""},domProps:{"innerHTML":_vm._s(_vm.lang.alphaNumericInfo(_vm.id))}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-194fb06e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/alphanumeric-id.vue
// module id = null
// module chunks = 